export default {
  pageTitle: 'Campaign performance',
  redemptionRevenue: {
    title: 'Redemption revenue',
  },
  emailEngagement: {
    title: 'Email engagement overview',
  },
  campaignEmailEngagement: {
    title: 'Campaign email engagement',
  },
  emailEngagementByCampaignType: {
    title: 'Email engagement by campaign type',
  },
}
